import useRequest from './Request'
const useApi = () => {

  const Request = useRequest()
  const Api = {
    get: (url) => Request(url),
    post: (url, body, headers, isFormData = false) => Request(url, { method: 'POST', body: body === null ? null : (isFormData ? body : JSON.stringify(body)) }, headers),
    put: (url, body, headers, isFormData) => Request(url, { method: 'PUT', body: (isFormData ? body : JSON.stringify(body)) }, headers),
    delete: (url, headers) => Request(url, { method: 'DELETE' }, headers),
  }
  return Api
}

export default useApi